import { useLayoutEffect } from "react";
import { useLocale as __useLocale } from "@/context/LocaleContext";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useLocale } from "../context/LocaleContext";
import brandMedia from "../data/brandMedia.json";
import { ACTIVE_SOCIAL_LINKS } from "../config/socialLinks";

const SITE_URL = "https://shuletaki.com.tr";
const DEFAULT_DESCRIPTION = "Shule Accessories: kolye, küpe, yüzük, bileklik, saç aksesuarı ve hediye seçkileri. Her Anında Sen.";
const BRAND_SAME_AS = ACTIVE_SOCIAL_LINKS.map(({ href }) => href);

export function Seo({ title, description, jsonLd, path, noindex = false, image = brandMedia.share, type = "website" }) {
  useLayoutEffect(() => {
    // React 19 hoists the current Helmet metadata; retire only the build-time fallback.
    document.head.querySelectorAll("[data-shule-static-seo]").forEach(node => node.remove());
  }, []);
  const { t: __t } = __useLocale();
  const { pathname } = useLocation();
  const { locale } = useLocale();
  const fullTitle = title ? `${__t(title)} | Shule Accessories` : __t("Shule Accessories | Her Anında Sen");
  const metaDescription = __t(description || DEFAULT_DESCRIPTION);
  const routePath = path || pathname;
  const canonicalPath = routePath.startsWith("/") ? routePath : `/${routePath}`;
  const staticRoutes = new Set(["/blog", "/hediye", "/shule-club", "/magazalar", "/kiosklar", "/bayilik", "/hakkimizda", "/iletisim", "/firma-bilgileri", "/tuketici-haklari", "/teslimat-ve-iade", "/guvenlik-politikasi", "/gizlilik", "/veri-silme", "/kullanim-kosullari"]);
  const normalizedPath = canonicalPath.replace(/\/$/, "") || "/";
  const canonical = `${SITE_URL}${(staticRoutes.has(normalizedPath) || normalizedPath.startsWith("/blog/")) ? normalizedPath + "/" : normalizedPath}`;
  const socialImage = image.startsWith("http") ? image : `${SITE_URL}${image}`;
  const brandImage = image === brandMedia.share;
  const imageAlt = brandImage ? brandMedia.alt : fullTitle;

  return (
    <Helmet>
      <html lang={locale} dir={locale === "ar" ? "rtl" : "ltr"} />
      <title>{__t(fullTitle)}</title>
      <meta name="description" content={metaDescription} />
      <meta name="robots" content={noindex ? "noindex,nofollow" : "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1"} />
      <link rel="canonical" href={canonical} />
      <meta property="og:locale" content={{tr:"tr_TR",en:"en_US",de:"de_DE",ar:"ar",fr:"fr_FR",es:"es_ES",ru:"ru_RU",zh:"zh_CN"}[locale]} />
      <meta property="og:site_name" content="Shule Accessories" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={socialImage} />
      <meta property="og:image:alt" content={imageAlt} />
      {brandImage && <meta property="og:image:width" content={String(brandMedia.shareWidth)} />}
      {brandImage && <meta property="og:image:height" content={String(brandMedia.shareHeight)} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={socialImage} />
      <meta name="twitter:image:alt" content={imageAlt} />
      <meta name="author" content="Shule Accessories" />
      <meta name="theme-color" content="#F7F1EB" />
      <script type="application/ld+json">{JSON.stringify({"@context":"https://schema.org","@type":"OnlineStore",name:"Shule Accessories",url:SITE_URL,logo:`${SITE_URL}/assets/img/logo.png`,sameAs:BRAND_SAME_AS})}</script>
      {(Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : []).map((schema, index) => (
        <script key={index} type="application/ld+json">{JSON.stringify(schema)}</script>
      ))}
    </Helmet>
  );
}
